export default "__VITE_ASSET__DJSDY95P__"